import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { PermissionsService } from '../../../shared/services/permissions.service';
import { ResourceDTO } from '../../../shared/types/permission.types';
import { ResourceFormComponent } from '../resource-form/resource-form.component';

@Component({
  selector: 'app-resource-create',
  imports: [CommonModule, RouterModule, ResourceFormComponent, PageHeaderComponent],
  templateUrl: './resource-create.component.html',
})
export class ResourceCreateComponent {
  private readonly permissionsService = inject(PermissionsService);
  private readonly router = inject(Router);

  readonly submitting = signal(false);
  readonly serverError = signal<string | null>(null);

  onSave(payload: ResourceDTO): void {
    this.submitting.set(true);
    this.serverError.set(null);
    this.permissionsService.createResource(payload).subscribe({
      next: (created) => {
        this.submitting.set(false);
        void this.router.navigate(['/permissions/resources', created.id]);
      },
      error: (err: unknown) => {
        this.submitting.set(false);
        this.serverError.set(
          toErrorMessage(err, 'La création a échoué.', {
            409: 'Une resource avec ce nom existe déjà.',
          }),
        );
      },
    });
  }

  onCancel(): void { void this.router.navigate(['/permissions/resources']); }
}
